import { render, staticRenderFns } from "./initializeCommunityManageList.vue?vue&type=template&id=c0489cba&scoped=true"
import script from "./initializeCommunityManageList.vue?vue&type=script&lang=js"
export * from "./initializeCommunityManageList.vue?vue&type=script&lang=js"
import style0 from "./initializeCommunityManageList.vue?vue&type=style&index=0&id=c0489cba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0489cba",
  null
  
)

export default component.exports